<template>
  <div>
    <swiper-answer
      @afterRender="afterRender"
      @beforeSwiperForward="beforeSwiperForward"
      @beforeSwiperBack="beforeSwiperBack"
    />
  </div>
</template>
<script>
import SwiperAnswer from './component/swiperAnswer'
import { getCookie, delCookie, relodPage } from '@/static/js/zjs.js'
import { adRenderSuccess } from '../plugin/adEvent'

export default {
  components: {
    SwiperAnswer
  },
  data() {
    return {
      child: {}
    }
  },
  create() {
    this.relodPage()
  },
  mounted() {
    if (getCookie('gobcak')) {
      delCookie('gobcak')
      window.location.reload()
    }
    this.relodPage()
    //  广告加载，变换样式
    adRenderSuccess(() => {
      if (this.$store.userInfo.vipLevel === 'nv' && document.querySelector('#banner_2_0')) {
        var adEle = document.querySelector('#banner_2_0')
        adEle.style.display = 'block'
        adEle.style.bottom = '1.07rem'
        setTimeout(() => {
          adEle.style.height = 'auto'
        }, 0)
        document.querySelector('.main').style.paddingBottom = 'calc( 1.07rem + 1.57rem )'
      }
    })
  },
  beforeDestroy() {
    var adEle = document.querySelector('#banner_2_0')
    if (adEle) {
      adEle.style.display = 'none'
    }
  },
  methods: {
    relodPage,
    // 完成权限校验和渲染图片后
    afterRender(opt, child) {
      const [right, resList] = opt

      this.child = child
    },
    // 向前滑动翻页前
    async beforeSwiperForward(e, next, child) {
      next()
    },
    beforeSwiperBack(e, next, child) {
      next()
    }
  }
}
</script>
<style lang=""></style>
